var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Item/Variant7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9871 3C14.323 5.06658 17.3716 6.14257 20.4871 6C20.9407 7.54302 21.0795 9.16147 20.8953 10.7592C20.711 12.3569 20.2075 13.9013 19.4145 15.3005C18.6216 16.6998 17.5555 17.9254 16.2796 18.9045C15.0037 19.8836 13.5439 20.5962 11.9871 21C10.4304 20.5962 8.97062 19.8836 7.69468 18.9045C6.41875 17.9254 5.35265 16.6998 4.55973 15.3005C3.76682 13.9013 3.26327 12.3569 3.07901 10.7592C2.89476 9.16147 3.03355 7.54302 3.48714 6C6.60267 6.14257 9.65131 5.06658 11.9871 3",
    stroke: "#9EA3AE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9873 12C12.5396 12 12.9873 11.5523 12.9873 11C12.9873 10.4477 12.5396 10 11.9873 10C11.435 10 10.9873 10.4477 10.9873 11C10.9873 11.5523 11.435 12 11.9873 12Z",
    fill: "#9EA3AE",
    stroke: "#9EA3AE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9873 12V14.5",
    stroke: "#9EA3AE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationDarkMode);
export default __webpack_public_path__ + "static/media/InformationDarkMode.cff324ec7c247a54f25da0ff6206fc7f.svg";
export { ForwardRef as ReactComponent };